import { createContext } from "react";
const SortingContext = /*#__PURE__*/createContext({
  columnDecorator: column => column
});
export default SortingContext;